module.exports = __webpack_public_path__ + "img/equifax.2bc5af79.svg";